export default __webpack_public_path__ + "static/media/viana_de_castelo.d6458a83.png";